<template>
  <DataList
    title="Пакети сплати"
    resource="payment-packages"
    :columns="columns"
    :get-items-fn="getPackages"
    :search-label="'Пошук за назвою пакета сплат'"
    :filter="filter"
  >
    <template v-slot:filters>
      <v-row dense>
        <v-col cols="3">
          <EnumSelect
            v-model="roleSaleOption"
            :items="saleOptionTypes"
            label="Вартість"
            placeholder="Виберіть варіант вартості"
            clearable
          />
        </v-col>
      </v-row>
    </template>
  </DataList>
</template>

<script>
import * as packagesApi from "../../../backend/packagesApi.js";
import EnumSelect from "@/components/selects/EnumSelect";
import useVatTypes from "../../../helpers/useVatTypes.js";

export default {
  components: {
    EnumSelect,
  },
  data: () => ({
    columns: [
      { title: "id", name: "id" },
      { title: "Найменування", name: "title", rowType: "wide" },
      { title: "Aртикул", name: "article", rowType: "wide" },
      {
        title: "Вартість, грн без ПДВ",
        name: "amount",
        type: "decimal",
      },
      {
        title: "Вартість, грн з ПДВ",
        name: "amountWithVAT",
        type: "decimal",
      },
      {
        title: "Годин за базовим тарифом:",
        name: "baseRateHours",
      },
      { title: "Примітки", name: "comments", cropLimit: 50 },
    ],
    roleSaleOption: null,
    saleOption: null,
  }),
  computed: {
    saleOptionTypes(){
      return [
        {
          value: 0,
          text: useVatTypes.WITH_VAT.title,
        },
        {
          value: 1,
          text: useVatTypes.WITHOUT_VAT.title,
        },
        {
          value: 2,
          text: useVatTypes.BOTH_VAT.title,
        },
      ];
    },
    filter(){
      return {
        saleOption: (this.roleSaleOption || this.roleSaleOption === 0) ? this.roleSaleOption : "",
      };
    },
  },
  watch: {
    roleSaleOption(val){
      this.saleOption = this.saleOptionTypes.find(
        (el) => el.value === val
      );
    },
  },
  methods: {
    getPackages(...args) {
      return packagesApi.getPackages(args[0], args[1], args[2], args[3]);
    },
  },
};
</script>
